export default __webpack_public_path__ + "static/media/pc.fc5d39f2.png";